export default {
  path: '/security_parameters',
  name: 'security_parameters',
  component: () => import('../components/securityparameter/Layout'),
  redirect: { name: 'SecurityParameterList' },
  meta: {
    breadcrumb: 'administration.securityparameter.securityparameters',
  },
  children: [
    {
      name: 'SecurityParameterList',
      path: '',
      component: () => import('../views/securityparameter/List'),
      meta: {
        breadcrumb: 'global.list',
      },

    },
    {
      name: 'SecurityParameterShow',
      path: ':id',
      component: () => import('../views/securityparameter/Show'),
      meta: {
        breadcrumb: 'administration.securityparameter.securityparameter',
      },
    },
    {
      name: 'SecurityParameterUpdate',
      path: ':id/edit',
      component: () => import('../views/securityparameter/Update'),
      meta: {
        breadcrumb: 'global.update',
      },
    },
  ]
};
